import React from 'react';
import { Link } from 'react-router';
import {node, bool, object, string, func, oneOfType} from 'prop-types';
import {pushLinkItem} from "../../utils/datalayer";

class TrackedLink extends React.Component {
	handleClick(e) {
		pushLinkItem(e);
	}

	render() {

		const {to, id, style, className, onClick, onMouseOver, onMouseOut, target, itemProp, rel, children,
			activeStyle,
			activeClassName,
			onlyActiveOnIndex } = this.props;

		if (to === "/where-to-buy" || to.startsWith('/product') || to === '#') {
			// console.log(to);
			return (
				<a href={to}
				   	id={id}
					style={style}
					className={className}
				   	onClick={onClick || this.handleClick}
					onMouseOver={onMouseOver}
					onMouseOut={onMouseOut}
					target={target}
					itemProp={itemProp}
					rel={rel}>
					{children}
				</a>
			);
		} else {
			return (
				<Link
					to={to}
					id={id}
					style={style}
					activeStyle={activeStyle}
					className={className}
					activeClassName={activeClassName}
					onlyActiveOnIndex={onlyActiveOnIndex}
					onClick={onClick || this.handleClick}
					onMouseOver={onMouseOver}
					onMouseOut={onMouseOut}
					target={target}
					itemProp={itemProp}
					rel={rel}
				>
					{children}
				</Link>
			);
		}
	}
}

// Define expected props
TrackedLink.propTypes = {
	to: oneOfType([
		string,
		object,
		func// react-router supports location objects too
	]).isRequired,
	id: string,
	style: object,
	activeStyle: object,
	className: string,
	activeClassName: string,
	onlyActiveOnIndex: bool,
	onClick: func,
	onMouseOver: func,
	onMouseOut: func,
	target: string,
	itemProp: string,
	rel: string,
	children: node.isRequired,
};

export default TrackedLink;


// WEBPACK FOOTER //
// ./src/pages/common/TrackedLink.js